<template>
  <div>
    <nav v-if="breadcrumb" class="py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'groups'}">Broadcast Messages</router-link>
          </div>
          <div class="text-xl text-primary">
            Broadcast schedules
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right">
            <button v-if="$store.getters.can('create_groups')"
                    style="color: white !important;" @click="showModals({modal: 'broadcast'})"
                    class="bg-teal-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              New Message
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-3 border rounded shadow-sm">
        <div class="font-semibold mx-2 text-gray-600">{{ title }}</div>
        <div class="flex justify-between pt-2 px-3">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full mb-3 ">
            <thead>
            <tr class="border-b font-bold">
              <td class="px-3 py-2"></td>
              <td class="px-3 py-2">Channel</td>
              <td class="px-3 py-2">Group</td>
              <td class="px-3 py-2">Owner</td>
              <td class="px-3 py-2">Created on</td>
              <td class="px-3 py-2">Dispatch at</td>
              <td class="px-3 py-2">Status</td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-t hover:bg-gray-200" v-for="(record,index) in records" :key="record.id">
              <td class="px-3 py-2 font-bold"> {{ offset + index + 1 }}</td>
              <td class="px-3 py-2">
                {{record.channel}}
              </td>
              <td class="px-3 py-2">{{ record.customerGroup.name }}</td>
              <td class="px-3 py-2">{{ record.createdBy.first_name + " " + record.createdBy.last_name }}</td>
              <td class="px-3 py-2">{{ record.created_at }}</td>
              <td class="px-3 py-2">{{ record.dispatch_at }}</td>
              <td class="px-3 py-2">{{record.status}}</td>
            </tr>
            </tbody>
          </table>
          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
        </div>
        <Pagination class="py-2 px-3" :total-count="recordsCount" :current-page="currentPage"
                    :tag="'Groups'" :offset="offset" :records-count="records != null ? records.length || 0 : 0"
                    :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import GraphQl from "@/services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "BroadcastSchedules",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: 10,
      recordsCount: 0,
      records: [],
      orgId: this.$store.getters.orgId,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    title: {type: String, default: 'Broadcast schedules'},
    rowsPerPage: {type: Number, default: 10},
    breadcrumb: {default: true, type: Boolean},
    id: String
  },
  mounted() {
    this.$root.$on("refresh", (data) => {
      if (data === 'schedules') this.loadStats()
    });
    this.loadStats();
  },
  watch: {
    recordsPerPage: function () {
      this.loadStats(this.currentPage)
    },
    searchString: function () {
      this.currentPage = 1;
    }
  },
  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  methods: {
    showModals(data) {
      this.$root.$emit("show_modal", data);
    },

    formatDate(timestamp, format) {
      return moment(timestamp).format(format);
    },

    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true
      let params = 'limit: ' + this.recordsPerPage + ', ' +
          'offset: ' + this.offset + ', ' +
          'order: "created_at desc", ' +
          'search: "' + this.searchString + '"';
      GraphQl.sendRequest(
          '{broadcast(id:"' + this.id + '") ' +
          '{schedules(' + params + '){id dispatch_at customerGroup{id name} channel created_at status createdBy{first_name id last_name id} } schedulesCount(' + params + ') }}')
          .then(response => {
            this.records = response.broadcast.schedules;
            this.recordsCount = response.broadcast.schedulesCount;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>
</style>